import React from "react";
import { Link } from "react-router-dom";

interface Props {
  children?: any;
  contentChildren?: any;
}

export function InlineTabContentProduct({
  children,
  actived,
  alias,
  onClick,
}: {
  children: any;
  actived: boolean;
  alias: string;
  onClick: (e: any) => void;
}) {
  return (
    <li className="nav-item">
      <Link
        to={alias}
        className={`nav-link ${actived ? "active" : ""}`}
        onClick={() => onClick(alias)}
      >
        {children}
      </Link>
    </li>
  );
}

export function InlineTabProduct(props: Props) {
  return (
    <div className="os-tabs-w">
      <div className="os-tabs-controls">
        <ul className="nav nav-tabs">{props.children}</ul>
      </div>
      <div className="tab-content">
        <div className="tab-pane active show">{props.contentChildren}</div>
      </div>
    </div>
  );
}
